import { render, staticRenderFns } from "./Bayi.vue?vue&type=template&id=4b412f6c&scoped=true&"
import script from "./Bayi.vue?vue&type=script&lang=js&"
export * from "./Bayi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b412f6c",
  null
  
)

export default component.exports